import React from 'react';

import {
  ContentGroup,
  Heading,
  Link,
  Main,
  Paragraph,
} from '@constellation/core';
import { useContent } from '@interstellar/react-app-content';
import { StyledLink } from 'client/components/styledLink/StyledLink';
import Helmet from 'react-helmet';

import { HmoPageContent } from './HmoPage.config';
import * as routes from '../manifest';

function HmoPage() {
  const {
    metaContent,
    backLabel,
    title,
    aHmoIs,
    needALicence,
    unlimitedFineTitle,
    youCouldBeFined,
    hmoLicenceLinkLabel,
    hmoLicenceLinkHref,
    mustTellLocalCouncil,
    hmoInWales,
    hmoInScotland,
    hmoInNorthernIreland,
  } = useContent<HmoPageContent>();

  return (
    <Main>
      <Helmet>
        <title>{metaContent.title}</title>
      </Helmet>
      <ContentGroup marginTop="05" marginBottom="none">
        <StyledLink
          iconPosition="left"
          data-testid="back-button-link"
          to={routes.LandlordSupport}
        >
          {backLabel}
        </StyledLink>
      </ContentGroup>
      <Heading as="h1" size="s7" marginTop="05">
        {title}
      </Heading>
      <Paragraph>{aHmoIs}</Paragraph>
      <Paragraph>{needALicence}</Paragraph>

      <Heading as="h2">{unlimitedFineTitle}</Heading>
      <Paragraph>{youCouldBeFined}</Paragraph>
      <Paragraph>
        <Link
          data-testid="do-i-need-hmo-licence-link"
          href={hmoLicenceLinkHref}
          external
        >
          {hmoLicenceLinkLabel}
        </Link>
      </Paragraph>
      <Paragraph>{mustTellLocalCouncil}</Paragraph>

      <Heading as="h2">{hmoInWales.title}</Heading>
      <Paragraph>{hmoInWales.mandatoryLicence}</Paragraph>
      <Paragraph>{hmoInWales.localCouncils}</Paragraph>

      <Heading as="h2">{hmoInScotland.title}</Heading>
      <Paragraph>
        {hmoInScotland.makeSure}
        <Link
          data-testid="registered-as-landlord-scotland-link"
          href={hmoInScotland.hmoLicenceLinkHref}
          external
        >
          {hmoInScotland.hmoLicenceLinkLabel}
        </Link>
        {hmoInScotland.couldBeFined}
        <Link
          data-testid="landlord-accreditation-scotland-link"
          href={hmoInScotland.accreditationLinkHref}
          external
        >
          {hmoInScotland.accreditationLinkLabel}
        </Link>
        {hmoInScotland.committedToMaking}
      </Paragraph>

      <Heading as="h2">{hmoInNorthernIreland.title}</Heading>
      <Paragraph>
        {hmoInNorthernIreland.letOutProperty}
        <Link
          data-testid="get-a-licence-norther-ireland-link"
          href={hmoInNorthernIreland.getALicenceLinkHref}
          external
        >
          {hmoInNorthernIreland.getALicenceLinkLabel}
        </Link>
        {hmoInNorthernIreland.lastFiveYears}
      </Paragraph>
    </Main>
  );
}

export default HmoPage;
